import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
  alpha,
} from "@mui/material";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import AuthFeedback from "../utils/AuthFeedback";

const RegistrationComplete = ({ email, onResend, onSignIn }) => {
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const resend = async () => {
    if (sending) return;
    setSending(true);
    setFeedback(null);
    try {
      await onResend(email);
      setFeedback({
        severity: "success",
        title: "Verification email sent",
        message: "Check your inbox and spam folder for the verification link.",
      });
    } catch (error) {
      setFeedback({
        severity: "error",
        title: "Email could not be sent",
        message:
          "Please wait a few minutes and try again. If the problem continues, contact support.",
      });
    } finally {
      setSending(false);
    }
  };
  return (
    <Stack spacing={2.5} sx={{ maxWidth: 440, mx: "auto" }}>
      <Avatar
        variant='rounded'
        sx={{
          width: 48,
          height: 48,
          borderRadius: 3,
          color: "primary.main",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
        }}
      >
        <MarkEmailReadOutlinedIcon />
      </Avatar>
      <Box>
        <Typography component='h1' variant='h5' fontWeight={700}>
          Verify your email
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Your account has been created. Follow the verification link sent to:
        </Typography>
        <Typography fontWeight={600} sx={{ mt: 1, overflowWrap: "anywhere" }}>
          {email}
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Check your spam folder if you cannot find it. Once verified, you can
          sign in.
        </Typography>
      </Box>
      <AuthFeedback feedback={feedback} />
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
        <Button
          variant='contained'
          onClick={onSignIn}
          disabled={sending}
          sx={{ boxShadow: "none" }}
        >
          Go to sign in
        </Button>
        <Button
          variant='outlined'
          onClick={resend}
          disabled={sending}
          startIcon={
            sending ? <CircularProgress size={16} color='inherit' /> : undefined
          }
        >
          {sending ? "Sending email..." : "Resend verification email"}
        </Button>
      </Stack>
    </Stack>
  );
};

export default RegistrationComplete;
